module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('h2', {
    staticClass: "chapterNumber"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/9780061745287_contents#ch_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/9780061745287_contents#ch_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Basics")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What is a homosexual?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A homosexual is a person whose feelings of sexual attraction are for someone of the same gender: male for male, female for female. In contrast, a heterosexual is a person whose feelings of attraction are for someone of the opposite gender.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("homosexual")]), _vm._v(" was first used by Karl Maria Kertbeny in an 1869 pamphlet in which he argued for the repeal of Prussia’s antihomosexual laws. (Prussia is now part of northern Germany.) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Homosexual")]), _vm._v(" combines the Greek word for “same” with the Latin word for “sex.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Homosexual people come in all shapes and sizes and from all walks of life, just like heterosexual people do, and are part of every community and every family. This means that everyone knows someone who is homosexual. Most people just don’t realize that they know, and perhaps love, someone who is homosexual, because many—if not most—homosexual people keep their sexual orientation a secret.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I wish I had known what a homosexual was when I was growing up in the 1960s and 1970s in Kew Gardens, New York, "), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("a comparatively bucolic New York City neighborhood about forty-five minutes from Manhattan by subway. At first I didn’t know exactly what a homosexual was, except that homosexuals were something very bad and disgusting. The popular image for someone of my generation was a creepy-looking guy in an overcoat who hid behind bushes and tried to lure children into his clutches with candy.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("As I grew into adolescence, I still wasn’t exactly sure what a homosexual was, never having seen one on television or having met one, but I knew that the most horrible thing you could call someone was a “faggot.” In summer camp there was always at least one boy who got tagged with that label. It was usually someone who always struck out at baseball. He was despised by the other boys and shunned by the girls.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One summer, when I was fourteen, I was that boy. It was also around this time when I was just beginning to understand that “faggot” meant more than just being bad at baseball. It had to do with not being like other boys, who at that age were starting to get girl-crazy in a way that made no sense to me. I can’t say I had any memorable attraction to those of my own gender back then, but I do recall thinking that my strapping eighteen-year-old counselor, Ted, was kind of cute—an observation I knew not to share with my bunkmates.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I was sixteen years old when I finally met someone I knew to be homosexual, and I was both shocked and relieved. Bob was no creepy-looking guy in an overcoat. He was a smart, devastatingly handsome (to me), and very confident college student who lived down the block. He didn’t lurk behind shrubs, and he never once offered me candy. He did, however, help dispel all the myths I’d grown up with about homosexuality.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Bob was the first person to explain to me that a homosex")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("ual is simply a man or woman whose feelings of sexual attraction are for someone of the same gender. One man could meet and fall in love with another man, my new friend explained, and one woman could fall in love with another woman. So simple, but to me it was a revolutionary idea, and it changed my life, especially since I had a wild crush on Bob and could now do what any normal sixteen-year-old would do: imagine a life that included living happily ever after with the object of my affections.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What is a gay person? Why do gay people call themselves “gay”?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A gay person is a man or woman who is a homosexual. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gay")]), _vm._v(" is a synonym for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("homosexual.")]), _vm._v(" The word has been used publicly by gay people since the late 1960s, when "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gay")]), _vm._v(" was adopted by homosexual men and women in the early gay civil rights movement and incorporated into slogans like “Gay is good!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gay")]), _vm._v(" was seen as a positive alternative to the clinical-sounding "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("homosexual.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gay")]), _vm._v(" was used as slang in place of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("homosexual")]), _vm._v(" as far back as the 1920s, almost exclusively within the homosexual community. If, for example, you wanted to indicate to a friend that a club or bar you planned to go to was frequented by homosexuals, you would say that it was a “gay place” or that there was a “gay crowd.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("One of the early examples of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gay")]), _vm._v(" being used in print to mean “homosexual” occurred in 1947. Lisa Ben, a young Hollywood secretary, used the word as part of the subtitle for a newsletter for lesbians that she published on her office typewriter. Lisa called her newsletter "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vice Versa: America’s Gayest Magazine.")]), _vm._v(" Other homosexual people knew that Lisa didn’t mean her magazine was simply full of fun, which is what most people ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("at the time would have thought, because "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gay")]), _vm._v(" was a word then typically used to mean “happy” or “fun,” as in “We had such a gay time at the party.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Not all homosexual people like using the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gay")]), _vm._v(" to describe themselves. And since "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gay")]), _vm._v(" has come to be used most often in association with male homosexuals, many homosexual women prefer to be called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lesbians.")]), _vm._v(" (See “What do gay people like to be called?” at the end of this chapter.)")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What is a lesbian?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A lesbian is a woman whose primary feelings of sexual attraction are for other women. In other words, a lesbian is a homosexual woman. Like gay men, lesbians come in all shapes and sizes and from all walks of life.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lesbian")]), _vm._v(" derives from the name of a Greek island, Lesbos, where Sappho, a teacher known for her poetry celebrating love between women, established a school for young women in the sixth century BC. Over time, the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lesbian,")]), _vm._v(" which once simply meant someone who lived on Lesbos, came to mean a woman who, like Sappho and her followers, loved other women.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Do gay men find all men sexually attractive? Do lesbians find all women sexually attractive?")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("No. Like most heterosexuals, gay people are pretty picky about the kind of person they find sexually attractive. So for all the heterosexual guys out there who are afraid that the gay guy at the gym or in their school shower is looking at them because they want to have sex with them, it’s okay to relax. They’re prob")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("ably looking at you because gay people, like all humans, are generally curious and like to look at other humans, clothed or unclothed.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What is a bisexual?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bisexual")]), _vm._v(" is the term used to describe a person who has feelings of sexual attraction for both men and women. But I think the term is misleading, because it suggests that such a person has the same strength of feelings for both men and women. Humans are far more complicated than that and more typically have stronger feelings of sexual attraction for one gender than the other.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was Alfred Kinsey who, in his landmark studies in the 1940s and 1950s on male and female sexuality, first revealed the rich variety of sexual feelings and expression. He developed a seven-point rating scale to represent human sexual attraction and experience.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Kinsey scale has a range of zero to six. The zero category includes all people who are exclusively heterosexual in their feelings of sexual attraction and report no homosexual experience or attraction. Category six includes those who are exclusively homosexual in experience and attraction. Everyone else falls somewhere in between.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some people are under the mistaken impression that people who are bisexual are involved in sexual relationships with both men and women at the same time. Though this may be the case for some people, most women and men who identify as bisexual and are in couple relationships have only a single partner at a time.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Are bisexuals just gay people who are afraid to admit they’re gay?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No. Most men and women who identify as bisexual are indeed bisexual. If there’s some confusion about this, it’s because some homosexuals, as they come to terms with accepting themselves, may at first say that they are bisexual, even thought they’re not. That’s what I did.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In my last year of high school I confided to a close male friend—who I thought might be gay—that I was bisexual. By this time I already knew I was gay because of the crush I had on Bob, the college student down the block, and I wasn’t the least bit interested in having a physical relationship with a woman. But somehow, “bisexual” didn’t sound nearly as bad as “gay,” and I really wasn’t ready to acknowledge to myself or the world the truth about my feelings. I was, needless to say, a fairly tortured and somewhat confused adolescent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I figured if I said that I was bisexual, then in the eyes of the world—and in my own eyes—I was at least half heterosexual. I rationalized that I could keep one foot in the gay world and the other safely in the heterosexual world, in word if not in deed. And I imagined that people would have an easier time accepting me if they thought I “went both ways.” But within a couple of years, when I felt more comfortable about being gay, I gave up claiming I was bisexual.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unfortunately, because of gay people like me, many people have the misconception that all men and women who say they are bisexual are homosexuals who are afraid to admit the truth about themselves. This is simply a misconception. Yes, some people who claim to be bisexual, as I did, are gay, but there are many people who have feelings of sexual attraction, to varying degrees, for both men and women—and they are called “bisexuals.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Is bisexuality the same as living “on the down low”?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No. “On the down low,” or “on the DL,” is a slang term that originated among African Americans. It is used to refer to men in heterosexual relationships who also have sex with men. Most often these men do not consider themselves to be gay or bisexual, and, in general, they keep this aspect of their sexual lives secret from their female partners and their families. They’re in hiding, or, in other words, “on the down low.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("What makes this a little confusing is that men who live on the down low are engaging in bisexual behavior and have a homosexual or bisexual sexual orientation. But they generally think of themselves as heterosexual men who have sex with men. If it sounds like I’m describing a person who is a mental contortionist, you’re right. But however confusing it may seem, this is simply another way that some men have chosen to adapt to living in communities that are less than accepting of people who live an openly gay life.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unfortunately, life on the down low usually involves unsuspecting female partners who are likely to have no idea that the men they are partnered with are leading secret lives.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For a fictional look into the lives of men who live on the down low, a great place to start is with the best-selling novels of E. Lynn Harris.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What is a transsexual or transgendered person?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The words "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("transsexual")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("transgendered")]), _vm._v(" are moving targets, and it seems that no two people I’ve spoken with can agree on exactly what they mean. So I turned for help to someone who works with transgendered and transsexual youth at a group home in New York City. What follows is a paraphrase of what he told me.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Transgender")]), _vm._v(" is an umbrella term that covers a broad range of “gender expression,” including drag queens and kings (see chapter 18, “Miscellaneous Questions”), cross-dressers, transgenderists, and transsexuals. These individuals are often people who find their gender identity—their sense of themselves as male or female—in conflict with their anatomical gender.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Transsexuals")]), _vm._v(" are people who have a gender-identity conflict. Some, although not all, transsexuals feel as though they are trapped in the wrong body. In other words, a man may feel he belongs in a woman’s body. And a woman may feel she belongs in a man’s body.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some transsexuals may live part-time in their self-defined gender, dressing and behaving in a manner generally associated with that gender. Others choose to live full-time in their self-identified gender. Some transsexuals also choose to undergo sexual-reassignment surgery so their anatomical gender matches their self-identified gender.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Is that the same as a transvestite or drag queen?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("See chapter 18, “Miscellaneous Questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("How can you tell who is gay? What do gay men and lesbians look like? Why are gay men effeminate and lesbians masculine?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For the most part, you can’t tell who is gay or lesbian from appearances, unless the man or woman in question is wearing a button or symbol that explicitly identifies him or her as homosexual.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Years ago the common assumption was that all gay and lesbian people were easily identifiable by well-established stereotypical mannerisms, affectations, dress, and so on. The typical lesbian was masculine in appearance and behavior and dressed in mannish clothing. The typical gay man was effeminate and paid more attention to the way he dressed and his grooming than “normal” guys. He might even wear a little makeup.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It turns out that many effeminate men—but certainly not all—are gay and that many masculine women—but certainly not all—are lesbians. But by and large, gay and lesbian people, like heterosexual people, come in all shapes, sizes, colors, and ages, as well as degrees of masculinity and femininity. And you certainly don’t have to be a gay man or heterosexual woman to enjoy a good pedicure or facial every now and then.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Do gay people choose to be gay? Are you born gay? Is it inherited? Can your parents make you gay? Can you be seduced or recruited into being gay? Do you become gay because of a bad sexual experience or because of sexual abuse?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We all make choices about how we conduct our lives. But there are fundamental aspects of ourselves about which we don’t get a choice—eye color, fingerprints, and left-or right-handedness, for example. We also don’t get a choice about our feelings of sexual attraction. I didn’t choose my same-gender feelings of sexual attraction any more than my brother and sister chose their opposite-gender feelings of sexual attraction.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("From an early age my younger brother thought women’s breasts were the most wondrous creations on earth. In stark ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("contrast, I had no idea what all the excitement was about. But Greg Louganis, the Olympic diver—now, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" was a different story. Seeing Greg on the diving board at the 1984 Olympics made me think "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" was the most wondrous creation on earth.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("No one knows exactly how feelings of sexual attraction get bestowed on each of us or how early in life, although contemporary research strongly suggests that there are both a genetic and a biological basis for what is proving to be an exceedingly complex puzzle. But whatever your own personal beliefs about how we come into existence—Darwin, God, and/or Mother Nature—your feelings of sexual attraction come to you very early in life (before or after birth) and are yours and yours alone and remain yours until the day you die—just like your fingerprints, your eye color, and your right-or left-handedness. And like these other genetically inheritable traits, sexual orientation has a genetically inheritable component—but no one knows exactly to what degree it is inheritable or what the mechanics of that inheritance might be. Like so much about us humans, sexual orientation remains something of a mystery.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("So whether some quack psychoanalyst would like to attribute homosexuality to domineering mothers or passive fathers, whether parents try to pin the blame on a bad sexual experience their child may have had, or whether your best friend thinks you’re a lesbian only because you were seduced by your college roommate, look at your fingerprints and remind yourself that feelings of sexual attraction are innate, immutable, and uniquely your own. What we choose to do about those feelings is an entirely different matter, which I address in the next question.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("One final thought on this subject: if all the women who have had bad sexual experiences with men became lesbians, I ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("suspect there wouldn’t be very many heterosexual women left. Think about that.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Can gay people choose to be heterosexual if they really want to be?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Well, yes, sort of, at least when it comes to behavior. And heterosexuals can be gay if they want to be as well, at least when it comes to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("their")]), _vm._v(" behavior; they may not like having sex with someone of the same gender, but they can certainly do it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But behaving heterosexually will not make a gay person’s feelings of same-gender attraction go away, just as behaving homosexually will not make a heterosexual person’s feelings of opposite-gender attraction go away. And, I might add, prayer won’t make feelings of sexual attraction go away, either, despite what various religious leaders have claimed in the past and to this day. Nor will “conversion” programs that claim to make gay people straight change anyone’s innate feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Prayer and conversion programs may help individuals suppress their feelings of same-gender sexual attraction for a time, maybe even years, but those feelings remain, just waiting to reassert themselves. And, really, is expressing those feelings such a bad thing? After all, feelings of sexual attraction, when handled responsibly by consenting adults, don’t hurt anyone, and have even been known to make people quite happy.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("This is how I see it in personal terms: Just as my left-handed father was forced in the 1930s to learn to use his right hand adequately to perform all the functions that came naturally to his left hand, I could learn to do the things heterosexual men do, even though it doesn’t come naturally to me. I don’t think I would be all that good at it, I know it wouldn’t be my first choice, ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("and I also know that in a very short time I would feel frustrated and more than a little bit irritable, but no more or less so than a heterosexual who was forced to live as a homosexual.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Plenty of people with same-gender sexual orientation choose for all kinds of reasons not to express their feelings of attraction and consciously decide to live a heterosexual life. Are they happy about it? Well, yes and no, but mostly no, if you judge by the past twenty years’ worth of conversations I’ve had with and e-mails I’ve received from men and women with same-gender orientation who were in heterosexual marriages—some for decades. These were generally people who felt torn between continuing in the outwardly heterosexual lives they’d created for themselves and, as one writer put it, “throwing myself from a cliff.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I know there are heterosexual people who believe that it shouldn’t be any big deal for gay people to “go straight.” But to them I offer this challenge: Try “going gay,” and see how much you like it. And then imagine marrying a same-gender partner and living that way for the rest of your life. And don’t forget the part about being monogamous. Then send me an e-mail in twenty years, and let me know how it worked out.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("If my parent or brother or sister is gay, does that mean I’ll be gay, too?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We’re back to genetics and biology. If your parent or sibling is gay, there may be a greater chance that you will be gay, too, than if your parent or sibling is not gay. Not because of association or influence, but because of genetics and biology. If there were reliable statistics about this that I felt comfortable with, I’d offer them. But there aren’t.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("I can tell you that in my family, as far as I know, I’m the only gay person to come along as far back as anyone can remember. (My grandmother remembers her great-grandmother, so we’re talking mid-nineteenth century.) I have my suspicions about one great-uncle who was not the most masculine guy in the world, but as I said earlier in this chapter, not all effeminate men are gay.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What about identical twins? If it’s genetic, then if one is gay, the other must be, too, right?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This is where things get interesting. In a study of identical twins, the scientists Michael Bailey and Richard Pillard found that where one twin is gay, the other twin has an approximately 50 percent chance of being gay. If sexual orientation were strictly genetic, both identical twins would always be gay or always heterosexual. So there are clearly biological factors other than genetics at work here. Stay tuned.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("How do you know if you’re gay?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The key to knowing your sexual orientation is recognizing your feelings of sexual attraction. The challenge for many gay and bisexual people is being honest with themselves about what they’re feeling. Because society can be so unaccepting of them, it’s difficult for many gay people to acknowledge and accept what they know in their heart of hearts to be true of themselves.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("One of the big challenges I faced in college as I began telling friends that I was gay was explaining to them "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("how")]), _vm._v(" I knew I was gay. Most often I answered their questions by asking them how they knew they were straight. They would usually answer ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("that they had never thought about it or that they “just knew.” Well, I just knew, too. For as long as I could remember I found certain men physically attractive, in the same way that I knew most men found certain women attractive and most women found certain men attractive.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Beyond that explanation, I usually tried to find an example my friends could relate to. One of the first people who asked me this question was my friend Cindy. The question came up during our junior year of college on a trip we made to New York City to see a ballet performance. I decided to use the ballet as an example of how I knew I was gay.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During intermission, I asked Cindy what she thought about the principal woman dancer. Cindy said that she thought she was an excellent performer and very beautiful. I told her that I felt exactly the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then I asked her what she thought of the virtually naked male dancer who had performed a masterful and aggressive solo just before intermission. I knew Cindy well enough to know what her answer would be. She said, as I expected, “Oh my God, he’s so handsome! He’s so sexy!” Again, I told her that I felt exactly the same way.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("The handsome and sexy dancer had left us both a little breathless and filled with desire. Using that example, I was able to convey to my friend that the experience of being attracted to someone—a man, in this case—was little different for me than it was for her. It was an experience so automatic that we didn’t have the chance to think about it before being hit by a quickening pulse. The difference, of course, was that almost everyone would consider Cindy’s feelings for the dancer to be perfectly normal. And though my feelings felt perfectly normal to me, there are ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("plenty of people who would choose a word other than "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("normal")]), _vm._v(" to describe my response to the male dancer.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Do you have to have a sexual experience to know for sure?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No. Sexual orientation has everything to do with feelings of sexual attraction and nothing to do with actual experience. As you grow through childhood, you become aware of your feelings of attraction. That awareness, no matter your orientation, does not require actual physical experience. If you think back to your own early awareness of your attractions, more likely than not you knew whether you were attracted to members of the same gender, the opposite gender, or both long before becoming sexually active.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That said, a sexual experience can certainly help confirm what you already sense to be true. At least, that was my experience.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Are straight people ever attracted to someone of the same sex? Are gay people ever attracted to someone of the opposite sex?")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Of course! Human sexuality is profoundly complex and not easily compartmentalized into the rigid categories we humans have created to try to bring some order to something that often defies order. So it should surprise no one that it’s perfectly normal for a homosexual person to have feelings of sexual attraction for someone of the opposite gender, just as it’s perfectly normal for a straight person to have feelings of sexual attraction ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("for someone of the same gender. It doesn’t mean that your feelings are strong enough to compel you to have sex with that person, but these feelings could easily be strong enough to make you feel good.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Even though these feelings of attraction are something almost all people experience at one time or another, they can still be very confusing. For example, the first time I had an erotic dream about a woman, I was probably twenty. I woke up in the morning stunned, wondering how I could possibly have had such a dream after finally accepting that I was gay. Could I have made a mistake? Was I really heterosexual?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Through the course of the day I realized that one heterosexual erotic dream was just that—nothing to get upset about. My feelings for men hadn’t changed, and beyond that one dream—as well as a few others over the years—I had no strong feelings of sexual attraction for women.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After talking with friends about my dream, I discovered I wasn’t the only gay man who had had a heterosexual erotic dream. And some of my straight friends acknowledged having had homosexual erotic dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("If you have a homosexual experience, does that make you gay? If you have a heterosexual experience, does that make you straight?")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("No. Physical behavior doesn’t determine or change your sexual orientation. Plenty of heterosexual people have had sexual relations with someone of the same gender, and plenty of gay and lesbian people have had sexual relations with someone of the opposite gender. These experiences have not changed anyone’s ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("basic sexual orientation, although they may have broadened a few horizons.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Is homosexuality normal? Is it unnatural?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I always hate when people answer a question with a question, but it seems appropriate here. What’s normal? What’s natural? And who gets to decide? To me, my sexual orientation seems quite normal and decidedly natural. Having sex with a woman felt abnormal and unnatural. Luckily for me, I found another man who feels the way I do and is as attracted to me as I am to him—in all kinds of ways—and we’ve been living what seems to me a pretty normal life as a couple for more than a decade.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("So are we normal in the sense that we’re in the majority? No. But neither are people who are left-handed or have blue eyes. Are we abnormal or unnatural because we don’t conduct our sexual lives as God or nature intended? Well, what exactly did God and nature intend?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I’ve heard some people argue that God and nature determined that penile-vaginal intercourse is the only natural or normal way to be sexually active. If we accept this assumption, then heterosexuals who engage in sexual activity other than penile-vaginal intercourse are engaging in unnatural and abnormal acts. Welcome to the club!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Is homosexuality a mental illness?")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("No. But I think that some of the rabid bigots and antigay activists I’ve come across over the years have emotional problems. ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("For example, is it normal to place a telephone call to a radio talk show for the express purpose of telling the show’s guest—me—that he deserves his rights, “including the right to be chained to my truck and dragged down the highway”? To me, that person sounds disturbed.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Gay people as a group were never mentally ill, but until 1973, when the American Psychiatric Association voted to remove homosexuality from its official list of mental illnesses, gay people had to live with the mental-illness label. (The American Psychological Association followed suit a little more than a year later.) The late psychologist Dr. Evelyn Hooker helped get the ball rolling in the mid-1950s when she demonstrated in a landmark study that gay men were on average just as sane as their nongay counterparts.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Can homosexuality be cured? What methods have been tried?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diseases can be cured. Sexual orientation is not a disease. Therefore, it can’t be cured. In other words, you could no more “cure” a gay person of his or her feelings of sexual attraction than you could “cure” a heterosexual person of his or her feelings of sexual attraction.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("But that hasn’t prevented plenty of people, including licensed mental health professionals, from trying. And the methods they’ve used over the years are the kinds of things you might read about in a horror novel, including electroshock therapy, brain surgery, hormone injections, and even castration. Other methods used in the past have included aversion therapy, in which, for example, male homosexuals were shown erotic pic")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("tures of men at the same time that an electric shock was applied to their genitals or they were induced to vomit.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Although “curing” homosexuality is no longer the goal of mainstream mental health professionals, there are individuals and organizations that maintain programs to “help” gay people change their orientation, and some of these groups and individuals are alleged to employ a number of the now discredited methods.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I like what “Dear Abby,” the advice columnist, has to say on this subject: “Any therapist who would take a gay person and try to change him or her should be in jail. What the psychiatrist should do is make the patient more comfortable with what he or she is—to be himself or herself.” Amen!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Are gay people more likely to molest children?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No. The most likely person to molest children is a heterosexual male. His most likely victim is a female child. For example, a study conducted by Children’s Hospital in Denver found that between July 1, 1991, and June 30, 1992, only 1 percent of 387 cases of suspected child molestation involved a gay perpetrator. Overwhelmingly, the study found that boys and girls alike said they were abused by heterosexual male family members, including fathers, stepfathers, grandfathers, and uncles.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What is the gay lifestyle?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There is no such thing as a “gay lifestyle,” just as there is no such thing as a “heterosexual lifestyle.” Gay and lesbian people, like all people, choose to live their lives in all different kinds of ways—or lifestyles—which may be very similar to yours or quite different.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Back in 1992, just after I moved back to New York City following the end of a long-term relationship, my friend Kate told me that she was worried that I’d go out and lead a wild “gay lifestyle.” Based on her misconceptions, she feared that I would go out to gay clubs, dance all night, drink too much, take drugs, probably strip my shirt off when things got too hot, and maybe even have unprotected sex in a dark corner.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Of course, some gay men live a wild, urban, single lifestyle—as do some heterosexual men—but given what my friend knew about me and the life I had led in the past, I was more likely to be in bed, alone, at 10:00 p.m. than heading out the door for a wild night at the clubs.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("How many gay and lesbian people are there?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If you know, please write to me, because from what I know, no one really knows. I’ve read more than a few studies, none of which is definitive. Part of the problem is that gay people aren’t always so eager to identify themselves. Another is deciding who counts. Do you count only people who identify as gay and are—or have been—sexually active? Do you count people who simply identify as gay? Or do you count everyone who has ever had a homosexual experience?")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("One of the more interesting studies I read was published in 1993 by the University of Chicago Press under the title "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Social Organization of Sexuality.")]), _vm._v(" The study found that the percentage of gay men and women in the U.S. population varied widely between the big cities, the suburbs, and rural areas. For example, in the top twelve largest cities, 10.2 percent of the men and 2.1 percent of the women reported having had a sexual partner of their own gender in the previous year. In the suburbs of ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("the top twelve cities, 2.7 percent of the men and 1.2 percent of the women reported having had a sexual partner of their own gender in the previous year. And for rural areas, the figures were 1.0 percent for men and 0.6 percent for women.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("My educated guess is that approximately 3 percent of men and about half that number of women have same-gender sexual orientation, whether or not they express it by having a relationship of some kind with a person of the same gender. But whatever the actual figures, there are undoubtedly tens of millions of gay and lesbian people around the world.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As far as the reasons for the difference between the number of gay men and the number of lesbians goes—it is a mystery that remains to be solved.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Have there always been gay people?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Homosexuality and homosexual behavior are not modern inventions, as is evident from historical writings and from depictions of homosexual behavior in ancient art.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Are there are a lot more gay people now than in the past?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This is a question my grandmother asked me. She told me that she remembered back in the 1940s seeing a man on the subway platform in her Brooklyn, New York, neighborhood who “held his cigarette a certain way, wore makeup, and dressed impeccably.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Because of this man’s manner and clothing, she just assumed he was gay, based on the stereotype with which she was familiar. “Now you see gay people on television, read about them ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("in the newspaper, and they have parades. Where did they all come from?” she asked.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Gay and lesbian people have always been a part of the population, but because most gay men and women look and act just like most nongay people, there was no way for my grandmother to know that there were other gay men and lesbians on the subway platform with her in addition to the one man she assumed was gay. The difference today is that many gay people no longer feel compelled to hide their sexual orientation, and they live their lives like everyone else. So it just seems like there are more gay people.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Do animals other than humans engage in homosexual behavior?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Scientists have observed consistent homosexual behavior in the animal kingdom in many different species, ranging from mountain rams and seagulls to gorillas. No one has yet suggested that this is the result of a passive father and a domineering mother.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Is homosexuality nature’s way of controlling the population?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If that is Mother Nature’s purpose, she hasn’t succeeded, primarily because many, if not most, gay and lesbian people—even to this day—hide their feelings of sexual attraction, enter heterosexual marriages, and have children. Besides which, a growing number of openly gay and lesbian individuals and couples are choosing to have children.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What are some common stereotypes about gay men and lesbians? Do gay men have better fashion and design sense than straight men? Are lesbians better athletes than straight women? Do all lesbians have cats? Do gay men lisp? Why don’t lesbians wear makeup?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Stereotypes don’t come completely out of nowhere, so I would be willing to bet that a greater percentage of gay men have better fashion and design sense than straight men. But this is certainly not a universal trait.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Over the years, because of my work, I’ve interviewed gay people in their homes across the country. And most often, their fashion and design sense is nothing to write home about—and that’s the case with lesbians and gay men just about equally. I might add that when I needed to buy clothes recently, I was helped in my choices by two lesbians who have far better fashion and design sense than I do.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As far as the other stereotypes I’ve listed in the above questions, well, no one has done a study as to whether lesbians make better athletes than straight women, have more cats than the average straight woman, or wear more or less makeup. But my guess is that if the marketing geniuses who have figured out how to sell expensive shampoo to children think that lesbians own more cats than other women, then they’ll find a way to identify and quantify that market and then create products and advertising that will get lesbians to buy more, and more expensive, cat food.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("And if gay men do indeed have speech impediments more frequently than straight men, speech therapists ought to think ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("about advertising their services in publications and on Web sites that reach gay men. (I think they’d be wasting their money.)")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Do gay men hate women? Do lesbians hate men?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Everyone is capable of hating, no matter what his or her sexual orientation or gender. But as a rule, no, gay men don’t hate women, and lesbians don’t hate men.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Do gay men and women hate straight people?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some gay and lesbian people have hostile feelings toward heterosexual people. This should come as no surprise, given some of the terrible things gay people have experienced at the hands of some straight people. But as a rule, no, gay people don’t hate straight people.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What does “GLBT,” “LGBT,” and “GLBTQ” stand for?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("These are acronyms that you’ll see used frequently in print to describe the increasingly diverse group of people who come under the umbrella of gay rights efforts and gay organizations. Here’s what they stand for:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("GLBT = gay, lesbian, bisexual, and transgender")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("LGBT = lesbian, gay, bisexual, and transgender")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("GLBTQ = gay, lesbian, bisexual, transgender, and queer; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("or")]), _vm._v(" gay, lesbian, bisexual, transgender, and questioning youth")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What do gay people like to be called?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Most gay people would like to be called by their given names. Regarding their sexual orientation, if you asked the average gay man, he would tell you that he prefers the word “gay.” If you asked the average gay woman, she would tell you that she prefers “gay” or “lesbian.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some gay people prefer to call themselves “queer” and find it liberating to embrace a word that was once used as a slur against homosexuals. They also find the word inclusive in comparison to gay, lesbian, bisexual, and so forth.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("What does the word “faggot” mean? What does the word “dyke” mean?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("These are words that most gay people do not like being called. Let’s start with “faggot,” or its abbreviated relative, “fag.” These words have evolved into general-purpose put-downs, wielded usually by young people against those they perceive to be stupid, dorky, weird, weak, etc. While “fag” and “faggot” are most often used against boys, they’re now used against girls, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Back in the 1970s, when I was a kid, “faggot” was a term of contempt used against those boys and men who were perceived to be homosexuals and/or less than masculine. And long before that, the word “faggot” was used to describe a bundle of sticks, twigs, or branches used for fuel. (I remember that when I was in college some of the more worldly smokers referred to cigarettes as fags, as in, “I desperately need a fag.”)")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("The word “dyke” is not nearly as versatile and is gender-specific. It’s most often used as a disparaging term for lesbians, ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("particularly those who are perceived to be masculine. It is also used against women—gay or straight—who refuse to conform to society’s expectations in terms of how they look and act.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("For more information on these two words, visit the GLSEN Web site, which offers a school lesson plan devoted to this subject: www.glsen.com.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Why do some gay people call themselves “fags” and “dykes”?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Like other minority groups, some gay and lesbian people playfully use words that are used by the larger population to put them down. Some say it’s a way of taking the sting out of those words. (I think it’s stupid, insulting, and degrading. But that’s just my opinion.)")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bear in mind that you can use these words playfully only if you yourself are gay or lesbian. There are, however, exceptions. One of my gay male friends is not at all bothered when his heterosexual women friends use the word “fag” while in his company. He knows they’re simply being playful and is not at all bothered by it.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "question.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Is there a gay and lesbian culture?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I thought I’d offer an explanation of gay culture given to me by the late Chuck Rowland, one of eight founders of the Mattachine Society, a gay rights organization started in Los Angeles in 1950 (which marked the birth of the gay rights movement in the United States). Rowland was one of the first people to argue that there was a distinct gay and lesbian culture.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("When I interviewed Rowland in 1989, he told me that he had an especially hard time in the 1950s explaining to other gay people what he meant by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gay culture.")]), _vm._v(" He said, “People would say, ‘Do you actually think we’re more cultured than anybody else?’ I would explain that I was using "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("culture")]), _vm._v(" in the sociological sense—as a body of language, feelings, thinking, experiences that we share in common. As we speak of a Mexican culture. As we speak of an American Indian culture.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the decades since Chuck Rowland first made his case for the existence of gay culture, gay and lesbian writers, artists, photographers, playwrights, choreographers, filmmakers, and so forth have created a very significant body of work for gay and lesbian people that we would normally associate with the cultural life of a community.")])])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  })]), _c('a', {
    attrs: {
      "id": "page41"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b430e74c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061745287_chapter_01.vue
// module id = 75
// module chunks = 0